import React, { useEffect } from 'react';
import './App.css';
import { ThemeProvider } from "styled-components";
import {theme} from "./theme/theme";

//REDUX
import { Provider, useDispatch } from "react-redux";
import configureStore from "./configureStore";
import Home from "./views/home";
import { loadConfigurationWorker } from "./redux/actions";

const store = configureStore();

export const version = "2.4.0";

function App() {
  return (
      <Provider store={store}>
          <ThemeProvider theme={theme}>
              <Home/>
          </ThemeProvider>
      </Provider>
  );
}

export default App;
